// src/shared/ui/notifications/ToastContainer.tsx
import React, { useEffect, useState } from "react";
import { toast } from "./toast";
import { Toast } from "./types";

const iconSvg: Record<Toast["type"], string> = {
  success: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`,
  error: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>`,
  warning: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`,
  info: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>`,
};

const closeSvg = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;

const bgMap: Record<Toast["type"], string> = {
  success: "bg-emerald-50 border-emerald-200",
  error: "bg-red-50 border-red-200",
  warning: "bg-amber-50 border-amber-200",
  info: "bg-blue-50 border-blue-200",
};

const ToastContainer = () => {
  const [items, setItems] = useState<Toast[]>([]);

  useEffect(() => {
    return toast.subscribe(setItems);
  }, []);

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 w-[calc(100%-2rem)] max-w-xs sm:max-w-sm pointer-events-none">
      {items.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto ml-auto rounded-lg border ${bgMap[t.type]} shadow-lg animate-slide-in p-2.5 sm:p-3`}
        >
          <div className="flex items-start gap-2">
            <span className="shrink-0 mt-0.5" dangerouslySetInnerHTML={{ __html: iconSvg[t.type] }} />
            <p className="flex-1 text-xs sm:text-[13px] font-medium text-slate-900 leading-snug break-words">
              {t.message}
            </p>
            <button
              onClick={() => toast.remove(t.id)}
              className="shrink-0 p-0.5 text-slate-400 hover:text-slate-600 transition-colors"
              dangerouslySetInnerHTML={{ __html: closeSvg }}
              aria-label="Fermer la notification"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
